export const cutDescriptionData = description => {
  if (description && description.length > 200) {
    var shortDescription = description.substr(0, 197)
    if (/^\S/.test(description.substr(197)))
      return shortDescription.replace(/\s+\S*$/, "") + "..."
  }
  return description
}
